"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledAnnounceKit = exports.StyledTopBar = exports.StyledMenuTab = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const announcekit_react_1 = __importDefault(require("announcekit-react"));
exports.StyledMenuTab = styled_components_1.default.div `
  background: #281850;
  padding: var(--p-space-050);
  border-radius: var(--p-border-radius-200);
  height: 36px;
  :hover {
    background: var(--p-color-bg-fill-brand-active);
    cursor: pointer;
  }
  .Polaris-Avatar__Initials {
    background: #f7b3a4;
  }
  .Polaris-Avatar__Text {
    color: var(--p-color-bg-inverse);
  }
`;
exports.StyledTopBar = styled_components_1.default.div `
  padding: 8px 16px;
  background-color: var(--p-color-bg-inverse);
  .Polaris-Avatar__Text {
    color: var(--p-color-bg-inverse);
  }
`;
exports.StyledAnnounceKit = (0, styled_components_1.default)(announcekit_react_1.default) `
  padding: 5px 10px;
  a.announcekit-widget-badge {
    margin-left: 10px;
  }
  #announcekit-whatsnew {
  }
`;
